import type { ChatMessageProps } from '../ChatMessage';
import { useEffect, useRef } from 'react';
import { ChatMessage } from '../ChatMessage';
import { TypingIndicator } from '../TypingIndicator';
import { ThreadContainer, EmptyState } from './ChatThread.styles';

export interface ChatThreadProps {
  emptyState?: React.ReactNode;
  messages: ChatMessageProps[];
  isTyping?: boolean;
}

export function ChatThread({ emptyState, messages, isTyping = false }: ChatThreadProps) {
  const threadEndRef = useRef<HTMLDivElement>(null);

  // Scroll to bottom whenever messages change or typing indicator appears/disappears
  useEffect(() => {
    if (threadEndRef.current) {
      threadEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isTyping]);

  return (
    <ThreadContainer>
      {messages.length === 0 ? (
        emptyState || <EmptyState>No messages yet. Start a conversation by entering a topic.</EmptyState>
      ) : (
        <>
          {messages.map((message) => (
            <ChatMessage key={message.id} {...message} />
          ))}
          {isTyping && <TypingIndicator />}
          <div ref={threadEndRef} />
        </>
      )}
    </ThreadContainer>
  );
}
